import React, { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import paymentService from "../../services/paymentInfo";
import PaymentForm from "../../components/Forms/PaymentForm";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import { toast } from "react-hot-toast";
import { useQueryClient } from "react-query";

const validationSchema = Yup.object().shape({
    img: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            if (value) {
                if (value?.type) {
                    return imageFormat.includes(value.type.split("/")[1]);
                }
                return true;
            } else {
                return false;
            }
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            if (value) {
                if (value?.type) {
                    return imageSize >= value.size;
                }
                return true;
            } else {
                return false;
            }
        }),
});
const EditPayment = ({ title }) => {
    const [loading, setLoading] = useState(true);
    const [paymentAr, setPaymentAr] = useState("");
    const [paymentEn, setPaymentEn] = useState("");
    const [img, setImg] = useState("");
    const navigate = useNavigate();
    const { id } = useParams();
    const queryClient = useQueryClient();
    useEffect(() => {
        const getPayment = id => {
            paymentService
                .getPayment(id)
                .then(res => {
                    if (res.data.data) {
                        setPaymentAr(res.data.data.text_ar);
                        setPaymentEn(res.data.data.text_en);
                        setImg(res.data.data.img);
                        setLoading(false);
                    }
                })
                .catch(err => navigate("/404", { replace: true }));
        };
        if (id) {
            getPayment(id);
        }
    }, [id]);

    const onSubmit = (values, { setSubmitting }) => {
        if (paymentAr !== "" && paymentEn !== "") {
            const data = {
                text_ar: paymentAr,
                text_en: paymentEn,
            };
            paymentService
                .updatePayment(data, id)
                .then(res => {
                    if (values.img !== img) {
                        const formData = new FormData();
                        formData.append("img", values.img);
                        paymentService
                            .updatePaymentImage(formData, id)
                            .then(res => {
                                queryClient.refetchQueries("getPayments");
                                toast.success("تم التعديل بنجاح");
                                setTimeout(() => {
                                    navigate("/payment-info", {
                                        replace: true,
                                    });
                                }, 1500);
                            })
                            .catch(err => {
                                console.log(err);
                                setSubmitting(false);
                            });
                    } else {
                        queryClient.refetchQueries("getPayments");

                        toast.success("تم التعديل بنجاح");
                        setTimeout(() => {
                            navigate("/payment-info", { replace: true });
                        }, 1500);
                    }
                })
                .catch(err => {
                    console.log(err);
                    toast.error("فشلت عملية التعديل");
                    setSubmitting(false);
                });
        } else {
            setSubmitting(false);
            toast.error("بعض الحقول فارغة");
        }
    };
    if (isNaN(Number(id) || !id)) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <PaymentForm
                initialValues={{ img: img }}
                paymentAr={paymentAr}
                paymentEn={paymentEn}
                setPaymentAr={setPaymentAr}
                setPaymentEn={setPaymentEn}
                isLoading={loading}
                btnText={"تعديل"}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            />
        </div>
    );
};

export default EditPayment;
